import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_x7p4nsae7r: FaireBrandEntity = {
  token: "b_x7p4nsae7r",
  type: "brand",
  name: "Pagel & Sons",
  avatarUrl:
    "https://cdn.faire.com/fastly/bb9e8cee8477de3313225d6b879d7d8d981f2982280a4f211716b068eec990f9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/96bc756b8e8a06b011f59493eacd38ab7839541ee4d62f9b30947faf8116c74b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bb9e8cee8477de3313225d6b879d7d8d981f2982280a4f211716b068eec990f9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/96bc756b8e8a06b011f59493eacd38ab7839541ee4d62f9b30947faf8116c74b.png",
  location: "Des Moines, IA, USA",
  minimumOrderDollars: 50,
  rating: 4,
  reviewCount: 7,
  isInsider: true,
  description:
    "Pagel & Sons is a family owned small business that specializes in handmade products crafted to bring beauty and goodness to every home. A husband and wife along with their 5 little boys launched Pagel & Sons (previously Made Known Market) 9 years ago out of their home. Their business name is two fold: The values of the business are quality goods at affordable prices using as many natural and/or recycled ingredients as possible to bring beauty and goodness to individuals, families and communities. Pagel & Sons loves using our company name to fundraise for important causes such as Foster Care as well as using our company name to highlight our fellow small and local businesses.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:42.863Z",
    importedBy: "entity-db-cli",
  },
};
